import React, { useEffect } from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

type PageLayoutProps = {
  children: React.ReactNode;
  description?: string;
  title: string;
};

const PageLayout = ({ children, description, title }: PageLayoutProps) => {
  useEffect(() => {
    document.title = `${title} | Skadisfinity Layout`;

    if (!description) return;

    const metaDescription = document.querySelector(
      'meta[name="description"]'
    );
    metaDescription?.setAttribute("content", description);
  }, [description, title]);

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-gray-100">
      <Header />
      <main className="container mx-auto px-4 py-12">
        <section className="mx-auto max-w-4xl">
          <div className="mb-10">
            <h1 className="mb-4 text-4xl font-bold text-gray-900">{title}</h1>
            {description && (
              <p className="text-lg leading-8 text-gray-600">{description}</p>
            )}
          </div>
          <div className="space-y-8 text-gray-700">{children}</div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default PageLayout;
